<template>
    <b-dropdown variant="transparent"
                dropup
                no-caret
                v-b-tooltip
                :toggle-class="buttonClass"
                title="Add to Project"
                menu-class="dropdown-menu-projects"
                @shown="$refs.projectsDropdown.fetchProjects()">
        <template v-slot:button-content>
            <slot name="button-slot"></slot>
            <i class="fa-lg fas fa-folder-open" v-if="!hasButtonSlot"/>
        </template>
        <projects-dropdown :url="projectsUrl"
                           ref="projectsDropdown"
                           @addToProject="handleAddAssetToProject"/>
    </b-dropdown>
</template>

<script>
  import ProjectsDropdown from "../../Search/ProjectsDropdown";
  import normalize from "json-api-normalize";
  import GeneralMixins from "../../../mixins/GeneralMixins";
  import Attributes from "../../../models/Attributes";

  export default {
    components: {ProjectsDropdown},
    props: ['projectsUrl', 'projectAssetsUrl', 'assetId', 'buttonClass'],
    mixins: [GeneralMixins],
    computed: {
      hasButtonSlot: function () {
        return !!this.$slots['button-slot']
      }
    },
    methods: {
      handleAddAssetToProject(project) {
        // TODO: move this logic to the projects store
        this.$http.patch(`${this.projectAssetsUrl}/${project.id}`, {
          project: {
            added_asset_ids: [this.assetId]
          }
        }).then(fulfilled => {
          const project = normalize(fulfilled.body).get(Attributes.projectAttributes);
          window.projectsStore.updateProject(project);

          const h = this.$createElement;
          const toastMessage = h('div', [
            'Asset was added to ',
            h(
              'a',
              {attrs: {href: `${this.projectsUrl}/${project.id}`}},
              [project.name]
            )
          ])

          this.showToast(toastMessage, "Success");
        }, rejected => {
          this.showErrorToast("There was an error while adding these assets");
        })
      }
    }
  }
</script>